module.exports = __webpack_public_path__ + "static/circle_of_wildfire-10012041a82b03d926a6bc7c09d347ef.png";